import React from 'react';
import { GenericFormPage } from '../../components/generic';
import { useConversation, Conversation } from './useData';
import { moduleConfig } from './config';

const Form: React.FC = () => {
  return (
    <GenericFormPage<Conversation>
      useData={useConversation}
      config={moduleConfig}
    />
  );
};

export default Form;
